export default "__VITE_ASSET__DpQ_qWBg__"